module.exports = __webpack_public_path__ + "img/step3.0dc9dd98.svg";